import { BasicButtonComponent } from '@jeppesen-foreflight/jmkw-toolkit';
import { ButtonParams } from '@jeppesen-foreflight/jmkw-types';

export const AIR_TEMPERATURE_BUTTON: ButtonParams = {
  iconName: 'icon-device_thermostat',
  automationKey: 'air-temperature-layer-button',
  tooltipText: 'Air Temperature Toggle',
  buttonComponent: BasicButtonComponent,
  stateFn: (button, layer) => {
    button.active = layer.visible;
  },
  submit: (button) => {
    const layer = button.toolkitApiService.getLayerById('air-temperature');
    if (layer) {
      layer.jepTools.toggleVisibility();
    }
  }
};
